<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">
                        <v-text-field :label="$t('Name_label')" v-model="Odeme.Ad" :error-messages="errors.collect('gibseri')"
                          v-validate="'required'" data-vv-name="gibseri" required>
                        </v-text-field>
                        <v-text-field :label="$t('Description')" v-model="Odeme.Aciklama"
                          :error-messages="errors.collect('odemeacik')" v-validate="'required'" data-vv-name="odemeacik"
                          required>
                        </v-text-field>
                      </div>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletekayit()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>

            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>
            </div>
                        <v-btn color="blue darken-1" flat @click.native="dialog = false">{{$t('Cancel')}}</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{$t('Payment-Method-Description')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="this.$t('Search')" append-icon="search">
        </v-text-field>

        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="hesapekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Payment-Method-Description')}) }} </span>
            </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Payment-Method-Description')}) }}</span>
        </v-tooltip>

      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.ID)" item>
            <td class="text-xs-left">{{ props.item.ID }}</td>
            <td class="text-xs-left">{{ props.item.Ad }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'İd',
            value: 'ID'
          },
          {
            text: this.$t('Name_label'),
            value: 'Ad'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          }
        ],
        loading: false,
        progress: false,
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        addgib: false,

        Odeme: {
          ID: '',
          Aciklama: '',
          Ad: ''
        },
        state: [],
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            gibseri: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            odemeacik: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        this.progress = true
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu,
          Type: '306'
        }
        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.progress = false

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },
    methods: {
      Getir(v) {

        this.addgib = false
        this.k = false
        this.m = true
        this.$validator.reset()

        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Ödeme Şekli Açıklama Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu,
          ID: v,
          Type: '306'
        }
        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Odeme = response.body[0]
        })
      },
      deletekayit: deletekayit,
      hesapekle: hesapekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
  }


  function vazgec() {
    this.dialog = false
  }



  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$validator.validateAll().then((result) => {
      if (result) {
        var params = {
          Explanation: this.Odeme.Aciklama,
          CompanyCode: credentials.SirketKodu,
          Name: this.Odeme.Ad,
          Type: '306'
        }

        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.dialog = false
          var params1 = {
            CompanyCode: credentials.SirketKodu,
            type: '306'
          }
          this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            }
          })
        })
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })
  }

  function hesapekle() {

    this.dialog = true
    this.Odeme = {}
    this.addgib = true
    this.dialog_baslik = 'Ödeme Şekli Açıklama Ekle'
    this.m = false
    this.k = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function deletekayit() {

    this.addgib = false
    if (window.confirm('Odeme Şekli\'ni silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        CompanyCode: credentials.SirketKodu,
        ID: this.Odeme.ID,
        Type: '306'

      }
      this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true


          var params1 = {
            CompanyCode: credentials.SirketKodu,
            Type: '306'
          }
          this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {

    this.addgib = false
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          ID: this.Odeme.ID,
          Explanation: this.Odeme.Aciklama,
          CompanyCode: credentials.SirketKodu,
          Name: this.Odeme.Ad,
          Type: '306'
        }

        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params1 = {
              CompanyCode: credentials.SirketKodu,
              Type: '306'
            }
            this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>